import moment from 'moment';
import React from 'react';
import { Encounter, getEncounterColors } from './utils';
import { medicalBookIcon } from '../components/common/Icons';

interface MedicalRecordLeftPanelProps {
    encounters?: Encounter[];
    selectedEncounter?: Encounter;
    onEncounterClick: (enc: Encounter) => void;
    onAllRecordClick: () => void;
}

const MedicalRecordLeftPanel: React.FC<MedicalRecordLeftPanelProps> = ({
    encounters,
    selectedEncounter,
    onEncounterClick,
    onAllRecordClick,
}) => {
    if (encounters && Array.isArray(encounters) && encounters.length > 0) {
        return (
            <div
                style={{ width: '302px !important', minWidth: 302 }}
                className="border-r border-neutral-6  bg-transparent"
            >
                <div className="flex flex-col h-full w-full relative">
                    <div className="flex flex-col absolute inset-0 overflow-y-auto">
                        <div className="flex flex-col space-y-24 py-16 px-8 lg:px-16 w-full">
                            <div
                                onClick={onAllRecordClick}
                                style={{ marginLeft: 45 }}
                                className={`flex items-center hover:shadow-tight-3 justify-between w-80p p-8 leading-6 bg-white rounded-full ${
                                    !selectedEncounter
                                        ? 'shadow-tight-3'
                                        : 'shadow-tight-1'
                                } h-56 cursor-pointer`}
                            >
                                <div className="flex items-center capitalize w-87p">
                                    <div
                                        style={{
                                            width: '36px !important',
                                            height: '36px !important',
                                        }}
                                        className="flex items-center justify-center w-36 h-36 bg-darwin-green-bg-light rounded-full"
                                    >
                                        {medicalBookIcon('fill-darwin-green-primary w-15 h-15')}
                                    </div>
                                    <div
                                        className={`text-13 truncate w-full text-neutral-1 ml-8 ${
                                            !selectedEncounter ? 'font-700' : 'font-400'
                                        }`}
                                    >
                                        All records
                                    </div>
                                </div>
                                {!selectedEncounter && (
                                    <div className="flex justify-center items-center w-16 h-16">
                                        <svg
                                            width="14"
                                            height="14"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 320 512"
                                            className="fill-neutral-1"
                                        >
                                            <path d="M113.3 47.41l183.1 191.1c4.469 4.625 6.688 10.62 6.688 16.59s-2.219 11.97-6.688 16.59l-183.1 191.1c-9.152 9.594-24.34 9.906-33.9 .7187c-9.625-9.125-9.938-24.38-.7187-33.91l168-175.4L78.71 80.6c-9.219-9.5-8.906-24.78 .7187-33.91C88.99 37.5 104.2 37.82 113.3 47.41z"></path>
                                        </svg>
                                    </div>
                                )}
                            </div>

                            {encounters
                                .sort((a, b) => b.period_start - a.period_start)
                                .map((encounter, idx) => {
                                    const {
                                        practitioner_name,
                                        period_start,
                                        id,
                                        class: classType,
                                    } = encounter;
                                    const period_start_ms = period_start * 1000;
                                    const monthKey = moment(period_start_ms).format('YYYY-MM');
                                    const isCurrentMonth =
                                        moment(period_start_ms).isSame(moment(), 'month') &&
                                        moment(period_start_ms).isSame(moment(), 'year');
                                    const monthLabel = isCurrentMonth
                                        ? 'This month'
                                        : moment(period_start_ms).format('MMMM YYYY');
                                    const day = moment(period_start_ms).format('DD');
                                    const dayOfWeek = moment(period_start_ms).format('ddd');

                                    const showMonth =
                                        idx === 0 ||
                                        monthKey !==
                                            moment(encounters[idx - 1].period_start * 1000).format(
                                                'YYYY-MM',
                                            );

                                    const { bg, color } = getEncounterColors(classType);

                                    const isSelected = selectedEncounter?.id === encounter.id;

                                    return (
                                        <React.Fragment key={id}>
                                            {showMonth && (
                                                <p className="leading-5 text-12 uppercase text-neutral-4 font-700 mb-8">
                                                    {monthLabel}
                                                </p>
                                            )}
                                            <div
                                                onClick={() => onEncounterClick(encounter)}
                                                className=" w-full"
                                            >
                                                <div className="flex items-center space-x-10 lg:space-x-16 cursor-pointer w-full">
                                                    <div className="w-10p text-center ">
                                                        <p
                                                            className={`text-16 ${
                                                                isSelected
                                                                    ? 'text-neutral-1'
                                                                    : 'text-neutral-4'
                                                            } font-700`}
                                                        >
                                                            {day}
                                                        </p>
                                                        <p
                                                            className={`text-10 ${
                                                                isSelected
                                                                    ? 'text-neutral-1'
                                                                    : 'text-neutral-4'
                                                            } font-500`}
                                                        >
                                                            {dayOfWeek}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={`flex hover:shadow-tight-3 items-center justify-between w-80p p-8 leading-6 bg-white rounded-32 ${
                                                            isSelected
                                                                ? 'shadow-tight-3 scale-103'
                                                                : 'shadow-tight-1 scale-100'
                                                        }`}
                                                    >
                                                        <div className="flex items-center capitalize w-87p">
                                                            <div className="hidden lg:block">
                                                                <div
                                                                    style={{
                                                                        color,
                                                                        backgroundColor: bg,
                                                                    }}
                                                                    className="flex items-center font-700 text-16 justify-center w-36 h-36 bg-neutral-8 rounded-full"
                                                                >
                                                                    {classType}
                                                                </div>
                                                            </div>
                                                            <div className="flex w-70p flex-col gap-4 lg:ml-8">
                                                                <div
                                                                    className={`text-14 truncate w-full font-700  ${
                                                                        isSelected
                                                                            ? 'text-neutral-1'
                                                                            : 'text-neutral-5'
                                                                    }`}
                                                                >
                                                                    {practitioner_name}
                                                                </div>
                                                                <span className="w-full text-11 font-400 text-neutral-1">
                                                                    {id}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        {isSelected && (
                                                            <div className="flex justify-center items-center w-16 h-16">
                                                                <svg
                                                                    width="14"
                                                                    height="14"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 0 320 512"
                                                                    className="fill-neutral-1"
                                                                >
                                                                    <path d="M113.3 47.41l183.1 191.1c4.469 4.625 6.688 10.62 6.688 16.59s-2.219 11.97-6.688 16.59l-183.1 191.1c-9.152 9.594-24.34 9.906-33.9 .7187c-9.625-9.125-9.938-24.38-.7187-33.91l168-175.4L78.71 80.6c-9.219-9.5-8.906-24.78 .7187-33.91C88.99 37.5 104.2 37.82 113.3 47.41z"></path>
                                                                </svg>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    );
                                })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    return null;
};

export default MedicalRecordLeftPanel;
